module.exports = __webpack_public_path__ + "img/chase.b82a4881.png";